module.exports = __webpack_public_path__ + "img/indian-w.0567bf72.svg";